/**
 * El error de la API, en su propio archivo porque lo necesitan los dos lados: el cliente que
 * lo lanza y los datos de ejemplo que lo simulan.
 *
 * El backend devuelve `{ mensaje, codigo }` redactado para leerse en pantalla: el front no
 * inventa mensajes de negocio.
 */
export class ErrorDeApi extends Error {
  constructor(
    mensaje: string,
    readonly codigo: string,
    readonly estado: number,
    readonly detalles?: unknown,
  ) {
    super(mensaje);
    this.name = 'ErrorDeApi';
  }
}

/**
 * Un 409 al pagar NO es un error técnico: es "alguien le pagó desde otra caja un segundo
 * antes", y es exactamente el caso que el sistema existe para atrapar. El mostrador lo lee y
 * lo muestra como el veredicto "YA COBRÓ" con los datos de ese pago.
 */
export function esConflicto(error: unknown): error is ErrorDeApi {
  return error instanceof ErrorDeApi && error.estado === 409;
}

export function mensajeDeError(error: unknown): string {
  return error instanceof ErrorDeApi ? error.message : 'No se pudo completar la operación. Probá de nuevo.';
}
